import { render, staticRenderFns } from "./OperatorAccessCard.vue?vue&type=template&id=4a5d0850"
import script from "./OperatorAccessCard.vue?vue&type=script&lang=ts"
export * from "./OperatorAccessCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports